export default __webpack_public_path__ + "static/media/Hood of the Merciless.0541a9ea.jpg";